export type QuizSections = Record<DefaultQuizSection, number>

export enum DefaultQuizSection {
  intro = 'intro',
  goal = 'goal',
  cycle = 'cycle',
  cycleChanges = 'cycleChanges',
  routine = 'routine',
}

export enum QuizBreakpoint {
  goal = 'goal',
  birthControlMethod = 'birthControlMethod',
  sideEffects = 'sideEffects',
  conceiveTiming = 'conceiveTiming',
  hormonalBirthControlUsage = 'hormonalBirthControlUsage',
  hormonalBirthControlHowLong = 'hormonalBirthControlHowLong',
  medicalConditions = 'medicalConditions',
  cycleChangesEmotionalRange = 'cycleChangesEmotionalRange',
  cycleChangesSkinConditions = 'cycleChangesSkinConditions',
  cycleChangesPainSymptoms = 'cycleChangesPainSymptoms',
  cycleChangesMucusTypes = 'cycleChangesMucusTypes',
  cycleChangesSexDrive = 'cycleChangesSexDrive',
  whichWearable = 'whichWearable',
  sleepWearableAW = 'sleepWearableAW',
  sleepWearable = 'sleepWearable',
  eligibleAppleWatch = 'eligibleAppleWatch',
  lastPeriodDates = 'lastPeriodDates',
}

export enum QuizOverlayColor {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}

export enum QuizSingleInputType {
  TEXT = 'TEXT',
  DATE = 'DATE',
}

export enum QuizOverlayBodySize {
  SUBTITLE = 'SUBTITLE',
  TITLE = 'TITLE',
}

export enum QuizInfoPageContentPadding {
  NONE = 'NONE',
  DEFAULT = 'DEFAULT',
}

export enum QuizInfoPageImageWidth {
  DEFAULT = 'DEFAULT',
  FULL = 'FULL',
}

export enum QuizInfoPageGradient {
  LAVENDER = 'LAVENDER',
  SALMON = 'SALMON',
}
